import { Button, ActionIcon, Tooltip } from "@mantine/core";
import { X } from "lucide-react";

interface ClearPlaygroundDataButtonProps {
    onClick: () => void;
}

export function ClearPlaygroundDataButton({ onClick }: ClearPlaygroundDataButtonProps) {
    return (
        <>
            <Tooltip label="Clear Data">
                <ActionIcon
                    variant="light"
                    color="red"
                    size="lg"
                    onClick={onClick}
                    hiddenFrom="sm"
                >
                    <X size={18} />
                </ActionIcon>
            </Tooltip>
            <Button
                variant="light"
                color="red"
                leftSection={<X size={16} />}
                onClick={onClick}
                visibleFrom="sm"
            >
                Clear Data
            </Button>
        </>
    );
}
